import type { Role } from "../../lib/admin/types";

const LABELS: Record<Role, string> = {
  student: "student",
  admin: "admin",
};

/**
 * Role marker. Deliberately quiet — it's metadata, not a status badge.
 */
export function RolePill({ role }: { role: Role }) {
  const isAdmin = role === "admin";
  return (
    <span
      className={
        "text-xs " +
        (isAdmin ? "text-[var(--accent)]" : "text-[var(--ink-faint)]")
      }
    >
      {LABELS[role]}
    </span>
  );
}
